/* Pink Fantasy Hub — countdown + click-to-play video. No dependencies. */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function startCountdown(root) {
    if (root.dataset.pfReady) return;
    root.dataset.pfReady = '1';
    var target = Date.parse(root.getAttribute('data-target'));
    if (isNaN(target)) return;
    var els = {
      d: root.querySelector('[data-unit="d"]'),
      h: root.querySelector('[data-unit="h"]'),
      m: root.querySelector('[data-unit="m"]'),
      s: root.querySelector('[data-unit="s"]')
    };
    var live = root.getAttribute('data-live-text');
    function tick() {
      var diff = Math.max(0, target - Date.now());
      if (els.d) els.d.textContent = Math.floor(diff / 86400000);
      if (els.h) els.h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      if (els.m) els.m.textContent = pad(Math.floor((diff % 3600000) / 60000));
      if (els.s) els.s.textContent = pad(Math.floor((diff % 60000) / 1000));
      if (diff === 0) {
        clearInterval(timer);
        if (live) {
          var msg = document.createElement('p');
          msg.className = 'pf__display pf-count__out';
          msg.style.fontSize = '44px';
          msg.textContent = live;
          root.replaceChildren(msg);
        }
      }
    }
    var timer = setInterval(tick, 1000);
    tick();
  }

  function startVideo(btn) {
    if (btn.dataset.pfReady) return;
    btn.dataset.pfReady = '1';
    var id = btn.getAttribute('data-video-id');
    if (!id) return;
    var loop = btn.getAttribute('data-loop') === 'true';

    // Sharp poster: fall back if YouTube has no max-res thumbnail (it returns a 120px grey image)
    var img = btn.querySelector('img[data-fallback]');
    if (img) {
      var fix = function () { if (img.naturalWidth && img.naturalWidth < 400) img.src = img.getAttribute('data-fallback'); };
      if (img.complete) fix(); else img.addEventListener('load', fix, { once: true });
    }

    function load(muted) {
      if (!btn.isConnected) return;
      var q = 'autoplay=1&rel=0&playsinline=1&modestbranding=1' + (muted ? '&mute=1' : '') +
        (loop ? '&loop=1&playlist=' + encodeURIComponent(id) : '');
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?' + q;
      iframe.title = btn.getAttribute('aria-label') || 'Video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      btn.replaceWith(iframe);
    }

    btn.addEventListener('click', function () { load(false); });

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (btn.getAttribute('data-autoplay') === 'true' && !reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { io.disconnect(); load(true); }
        });
      }, { threshold: 0.5 });
      io.observe(btn);
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-pf-countdown]').forEach(startCountdown);
    (scope || document).querySelectorAll('[data-pf-video]').forEach(startVideo);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // Re-run when sections are edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
